import Box from "@mui/material/Box";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import Button from "@mui/material/Button";

import CropRotateIcon from "@mui/icons-material/CropRotate";

import Grid from "./Grid";
import { actionMapMapviewChangeRequested } from "../Map/MapRedux";
import { actionAddAlert, actionDeleteAlert } from "../Alert";
import Tooltip from "@mui/material/Tooltip";

import { trackEvent } from "../../tracking";

const root_ = (theme) => ({
  marginBottom: "2px",
  display: "flex",
  flexDirection: "column",
  "&:hover": {
    "& button": {
      borderRadius: "0px",
    },
  },
  "& .MuiButton-root": {
    color: "black",
  },
});

const widget_ = (theme) => ({
  // 44x44 min size is needed to meet this accessibility requirement:
  // https://www.w3.org/WAI/WCAG22/Understanding/target-size-enhanced.html
  width: 44,
  height: 44,
  minWidth: "unset",
  backgroundColor: "#ffffff",
  border: "1px solid #f0f0f0",
  fontSize: "0.7rem",
  [theme.breakpoints.down("sm")]: {
    width: 34,
    "& .MuiSvgIcon-root": {
      fontSize: "1.25rem",
    },
  },
});

const sharpBtmEdges_ = (theme) => ({
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
});

const active_ = (theme) => ({
  backgroundColor: "#4555b5",
  color: "white !important",
});

export default function Rotate() {
  const dispatch = useDispatch();

  const [expand, setExpand] = useState(false);
  const [gridVisible, setGridVisible] = useState(false);

  const handlePopoverOpen = () => {
    setExpand(true);
  };
  const handlePopoverClose = () => {
    setExpand(false);
  };
  const toggleGridVisisble = () => {
    setGridVisible(!gridVisible);
  };

  const resetRotationAndPitch = () => {
    dispatch(
      actionMapMapviewChangeRequested({
        bearing: 0,
        pitch: 0,
      }),
    );
  };

  useEffect(() => {
    const toggleGridVisisble = () => {
      setGridVisible(!gridVisible);
    };

    const resetRotationAndPitch = () => {
      dispatch(
        actionMapMapviewChangeRequested({
          bearing: 0,
          pitch: 0,
        }),
      );
    };

    if (gridVisible) {
      dispatch(
        actionAddAlert({
          id: "rotation",
          title: "Rotate Map - Adjust Sliders to Rotate and Tilt",
          buttonLabel: "RESET",
          onClick: resetRotationAndPitch,
          onClose: toggleGridVisisble,
        }),
      );
      trackEvent({
        category: "Map Widget",
        action: "Rotate Tool",
      });
    } else {
      dispatch(actionDeleteAlert("rotation"));
    }
  }, [dispatch, gridVisible]);

  return (
    <>
      <Box
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        sx={root_}
      >
        <Tooltip title="Rotate Map (CTRL + Drag Mouse)" placement="left">
          <Button
            variant="contained"
            sx={[widget_, gridVisible && active_, expand && sharpBtmEdges_]}
            onClick={toggleGridVisisble}
            onDoubleClick={resetRotationAndPitch}
          >
            <CropRotateIcon />
          </Button>
        </Tooltip>
      </Box>
      <Grid visible={gridVisible} />
    </>
  );
}
